import React from "react";
import classes from "./styles/style.module.css";
import PreMatchMenuElement from "../questions/PreMatchMenuElement";
import TestImg from "../../../assets/images/joftPooch/testImg.png";
import PictureTestImg from "../../../assets/images/joftPooch/pictureTestImg.jpg";
import RangeTestImg from "../../../assets/images/joftPooch/rangeTestImg.png";
import PuzzleTestImg from "../../../assets/images/joftPooch/puzzleTestImg.png";
import OrderTestImg from "../../../assets/images/joftPooch/orderTestImg.png";
import DiffrenceImg from "../../../assets/images/joftPooch/diffrenceTestImg.png";
import UploadImg from "../../../assets/images/joftPooch/uploadFile.png";
import ChainImg from "../../../assets/images/joftPooch/chain.png";
// import WordImg from "../../../assets/images/joftPooch/WordImg.png";
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 1, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2,
    },
  },
};

const QuestionTypes = [
  {
    text: "تستی",
    color: "blue",
    type: "multipleChoice",
    src: TestImg,
    score: 10,
  },
  {
    text: "ارسال فایل",
    color: "blue",
    type: "file",
    src: UploadImg,
    score: 110,
  },
  {
    text: "تصویری",
    color: "blue",
    type: "multipleImageChoice",
    src: PictureTestImg,
    score: 9,
  },
  {
    text: "طیفی",
    color: "purple",
    type: "range",
    src: RangeTestImg,
    score: 11,
  },
  {
    text: "پازل",
    color: "purple",
    type: "puzzle",
    src: PuzzleTestImg,
    score: 15,
  },
  {
    text: "مرتب کردن",
    color: "pink",
    type: "sorting",
    src: OrderTestImg,
    score: 12,
  },
  {
    text: "کشف تفاوت",
    color: "pink",
    type: "difference",
    src: DiffrenceImg,
    score: 15,
  },
  {
    text: "وصل کردن",
    color: "lightBlue",
    type: "connecting",
    src: ChainImg,
    score: 14,
  },
  // {
  //   text: "کلمه بازی",
  //   color: "lightBlue",
  //   type: "wordgame",
  //   src: WordImg,
  //   score: 20,
  // },
  {
    text: "لورفته",
    color: "blue",
    type: "",
    src: UploadImg,
    score: "_",
  },
];

const Preview = ({ matchId }) => {
  let menuElementst = QuestionTypes.map((el, index) => {
    return (
      <PreMatchMenuElement
        id={matchId}
        type={el.type}
        typeText={el.text}
        bgColor={el.color}
        src={el.src}
        score={el.score}
        key={index}
      />
    );
  });

  return (
    <div className={classes.previewContainer}>
      <h3>پیش نمایش</h3>
      <motion.div
        variants={container}
        initial="hidden"
        animate="visible"
        className={classes.questionMenuContainer}
      >
        {menuElementst}
      </motion.div>
    </div>
  );
};

export default Preview;
